/*
 * @Author: vinc
 * @LastEditTime: 2020-11-03 13:50:06
 */
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'babel-polyfill'

import Es6Promise from 'es6-promise'
require('es6-promise').polyfill()
Es6Promise.polyfill()


import Vue from 'vue'
import App from './App'
import router from './router'
import store from '@/store/store.js'
import base from '@/plugins/base'
import '@/assets/css/main.less';
import Moment from 'moment'
import axios from '@/plugins/axios'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import Public_components from '@/components/index';

console.log(process.env.APP_SERVER)
import apiData from '@/assets/js/http.js';
import pathData from '@/assets/js/path.js';
axios.defaults.baseURL = apiData[process.env.APP_SERVER].api


Vue.use(ElementUI)
Vue.use(base);
Vue.use(Public_components);
import * as filters from '@/assets/js/filters.js';

Object.keys(filters).forEach(key => { //过滤器挂载在Vue上
  Vue.filter(key, filters[key])
})


router.afterEach((to, from) => {
  // if (!urls.includes(to.path)) {
  //   let token = sessionStorage.getItem('tokenObj') ? JSON.parse(sessionStorage.getItem('tokenObj')) : null;
  //   if (token && token.isUsed == 1) {
  //     router.replace("/state").catch(err => {
  //       console.log('router error')
  //     });
  //   }
  //   if (!token) {
  //     router.replace('/login').catch(err => {
  //       console.log('router error')
  //     })
  //   } else {
  //     store.commit("SET_TOKEN", token)
  //     axios.defaults.headers.common['authorization'] = token.authorization
  //   }
  // }
})

// if (sessionStorage.getItem('temptoken')) {
//   store.commit("SET_TEL", JSON.parse(sessionStorage.getItem('temptel')))
//   axios.defaults.headers.common['TempToken'] = JSON.parse(sessionStorage.getItem('temptoken'))
// }

Vue.config.productionTip = false
Vue.prototype.$axios = axios;
Vue.prototype.$moment = Moment;
Vue.prototype.$pathUrls = pathData[process.env.APP_SERVER]

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: {
    App
  },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js